export const TYPES = {
  TASK: 'TASK_TREE',
  CEH: 'CEH_TREE'
}

const arrayToTree = arr => {
  if (!Array.isArray(arr)) {
    return {}
  }

  const keys = [...new Set(arr)]
  return keys.reduce((prev, curr) => ({ ...prev, [curr]: true }), {})
}

const treeToArray = tree => {
  const arr = Object.entries(tree).reduce((prev, [key, val]) => {
    if (val) {
      return [...prev, key]
    }

    return prev
  }, [])

  return [...new Set(arr)]
}

export const loadTree = key => {
  const loaded = sessionStorage.getItem(key)
  if (!loaded) {
    return {}
  }

  try {
    const keyArr = JSON.parse(loaded)
    return arrayToTree(keyArr)
  } catch (_) {
    console.error(_)
    return {}
  }
}

export const saveTree = (tree, key) => {
  try {
    const toSave = treeToArray(tree)
    sessionStorage.setItem(key, JSON.stringify(toSave))
  } catch (_) {
    console.warn('Saving tree failed', { key, tree })
  }
}
